/* check.icon.svg.js */

"use strict";
module.exports = {
    icon: `
        <svg viewBox="0 0 16 16" preserveAspectRatio="none">
            <g>
                <path class="foreground-gl" d="M6.1,12.6L2.5,8.9c-0.2-0.2-0.2-0.6,0-0.8l1.4-1.3c0.2-0.2,0.6-0.2,0.8,0l1.4,1.4c0.2,0.2,0.6,0.2,0.8,0l4.4-4.9
                    c0.2-0.2,0.6-0.2,0.8,0l1.4,1.3c0.2,0.2,0.2,0.6,0,0.8l-6.6,7.2C6.7,12.8,6.3,12.9,6.1,12.6z"/>
            </g>
        </svg>`,
};
